import { render, staticRenderFns } from "./SizeScreen.vue?vue&type=template&id=30c656cc&"
import script from "./SizeScreen.vue?vue&type=script&lang=js&"
export * from "./SizeScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports